module.exports = __webpack_public_path__ + "img/mySignatureEle.21e57a85.svg";